import { render, staticRenderFns } from "./DownloadPC.vue?vue&type=template&id=0112fb68&scoped=true"
import script from "./DownloadPC.vue?vue&type=script&lang=js"
export * from "./DownloadPC.vue?vue&type=script&lang=js"
import style0 from "./DownloadPC.vue?vue&type=style&index=0&id=0112fb68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0112fb68",
  null
  
)

export default component.exports